module.exports = __webpack_public_path__ + "static/media/1914409_1150872564530_3883785_n.57e6fedc.jpg";